module.exports = __webpack_public_path__ + "static/media/btn.a1cb2430.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity22/btn.png
// module id = 363
// module chunks = 0